export default {
  isLoading: false,
  validationErrorMessage: '',
};
